import { render, staticRenderFns } from "./iochart.vue?vue&type=template&id=587a517d&scoped=true&"
import script from "./iochart.vue?vue&type=script&lang=js&"
export * from "./iochart.vue?vue&type=script&lang=js&"
import style0 from "./iochart.vue?vue&type=style&index=0&id=587a517d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a517d",
  null
  
)

export default component.exports